import { TemplateType } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaRegFileAlt, FaRegStickyNote } from 'react-icons/fa';

export const templateTypeOptions = {
  [TemplateType.ParticipantDocument]: {
    label: 'Document',
    value: TemplateType.ParticipantDocument,
    raw: TemplateType.ParticipantDocument,
    color: 'purple',
    icon: <FaRegFileAlt />,
  },
  [TemplateType.ParticipantNote]: {
    label: 'Note',
    value: TemplateType.ParticipantNote,
    raw: TemplateType.ParticipantNote,
    color: 'orange',
    icon: <FaRegStickyNote />,
  },
};

interface Props extends ChakraV3.TagProps {
  type: TemplateType;
}

export const TemplateTypeTag = (props: Props) => {
  const { type, ...rest } = props;

  const { label, color, icon } = templateTypeOptions[type];

  return (
    <ChakraV3.Tag size='sm' colorPalette={color} startElement={icon} {...rest}>
      {label}
    </ChakraV3.Tag>
  );
};
